import {
  BoxSummaryViews,
  type useGetCurrentBoxSummaryView,
} from 'routes/Menu/hooks/useGetCurrentBoxSummaryView'

import type { LoggedOutBoxSummaryStep } from './types'

type LegacyBoxSummaryView = ReturnType<typeof useGetCurrentBoxSummaryView>

const legacyViewToTreatmentStepMap: Record<BoxSummaryViews, LoggedOutBoxSummaryStep> = {
  [BoxSummaryViews.POSTCODE]: 'postcode',
  [BoxSummaryViews.DELIVERY_SLOT]: 'delivery',
  [BoxSummaryViews.PORTION_SIZE]: 'portionSize',
  [BoxSummaryViews.DETAILS]: 'summary',
}

export const legacyViewToTreatmentStep = (view: LegacyBoxSummaryView): LoggedOutBoxSummaryStep => {
  if (!view) {
    return 'postcode'
  }

  return legacyViewToTreatmentStepMap[view] ?? 'postcode'
}
